import lang from "element-ui/lib/locale/lang/pt-br";
export default {
  ...lang,
  failed: "falhou",
  success: "sucesso",
  暂未开通功能: "A funcionalidade está passando por ajustes, com expectativa de lançamento em breve.",
  "功能正在研发中...": "A funcionalidade está passando por ajustes, com expectativa de lançamento em breve.",
  服务: "SERVIÇOS",
  服务介绍: "Introdução de Serviços",
  国际运输: "Remessa Expressa Internacional",
  合作意向: "Seja Nosso Cliente",
  首页: "Home",
  VIEW: "Consulta",
  "Expand More": "Expandir mais",
  关于我们: "Sobre a J&T",
  帮助中心: "CENTRAL DE AJUDA",
  公司简介: "Sobre Nós",
  加入我们: "Trabalhe Conosco",
  网点查询: "Encontre uma Unidade J&T",
  "contact us": "FALE CONOSCO",
  "12 Countries’ Official Websites": "SITES OFICIAIS, 8 PAÍSES",
  "J&T Express exclusive APP": "J&T EXPRESS APP",
  "J&T Express exclusive APP One-click order, real-time query, worry-free delivery, express surprise":
    "APP exclusivo da J&T Express. Faça seu pedido, rastreie em tempo real com apenas um clique, sem surpresas e sem preocupações.",
  CHINA: "China",
  SINGAPORE: "Singapura",
  CAMBODIA: "Camboja",
  THAILAND: "Tailândia",
  PHILIPPINES: "Filipinas",
  MALAYSIA: "Malásia",
  VIETNAM: "Vietnã",
  INDONESIA: "Indonésia",
  ARABIA: "SAUDI ARABIA",
  UAE: "UAE",
  EGYPT: "EGYPT",
  MEXICO: "MEXICO",
  BRAZIL: "BRAZIL",
  "999开头的及J开头的单号查询": "Só pesquisar números de rastreamento começado com 999 e J",

  pageIndex: {
    searchPlaceholder: "Acompanhe seu pedido",
    onlineMail: "Envio online",
    Inquires: "Consulta",
    ShippingRates: "Manda fácil",
    TransitTime: "Tempo de envio",
    ServicePoints: "Franquias",
    ServiceCoverage: "Área de cobertura",
    Address: "***,***,***,******",
    phone: "***-****-****",
    email: "meajuda@jtexpress.com.br",
    税号: "CPF/CNPJ",
    税号不能为空: "CPF/CNPJ não pode ser vazio",
    "CPF/CNPJ为11~14位数字": "CPF/CNPJ composto por 11-14 números",
    "对不起，没有找到该订单的信息": "Desculpe, as informações deste pedido",
    请确认订单号是正确的: ". não foram encontradas. Confirme se o número do pedido está correto.",
  },
  pageOnlineOrder: {
    请完善地址信息: "Por favor complete la dirección",
    我们将上门取件: "La recolección se realizará en su puerta",
    寄件人信息: "Informacion de envio",
    从通讯录选择: "Seleccionar de la lista de direcciones",
    清空: "Vacío",
    添加到通讯录: "Agregar a libreta de direcciones",
    省市区: "省市区",
    详细地址: "详细地址",
    详细地址1: "Dirección 1",
    详细地址2: "Dirección 2",
    收件人信息: "Información de recepción",
    物品信息: "Informacion del objeto",
    物品类型: "Tipo de objeto",
    物品名称: "Nombre del objeto",
    结算方式: "Payment method",
    物品重量: "物品重量",
    备注: "Notas",
    下单: "Pedir",
    寄件地址与收件地址不能相同: "寄件地址与收件地址不能相同",
    "预估费用(不含税)": "预估费用(不含税)",
    "预估费用(含税)": "Precio estimado (impuestos incluidos)",
    预估费用: "Precio estimado",
    最终运费以收派员为准: "最终运费以收派员为准",
    立即下单: "立即下单",
    下单成功: "Orden exitosa",
    业务员正在快马加鞭赶过来: "El mensajero se dirige rápidamente a la dirección del remitente, mantenga el teléfono encendido",
    订单号: "Número de orden:",
    复制: "Copiar",
    关闭: "Cerrar",
    查看订单: "Ver",
    产品类型: "Tipo de producto",
    请选择产品类型: "Elija tipo de producto",
    姓名: "Nombre",
    手机号: "Numero telefónico",
    请输入手机号: "Por favor ingresa tu número telefónico",
    手机号码: "Numero telefónico",
    请输入姓名: "Por favor ingresa tu nombre",
    请输入详细地址: "Favor de ingresar la dirección",
    请选择物品类型: "Elija tipo de objeto",
    请输入物品名称: "Por favor ingrese el nombre del objeto",
    请选择付款方式: "Seleccione el método de pago",
    请输入物品重量: "Ingrese peso del objeto",
    请输入备注: "Por favor ingrese las notas",
    寄付现结: "Pagado",
    到付现结: "Pago contra entrega",
    点击填写寄件人信息: "Click para llenar la informacion de envío",
    点击填写收件人信息: "Click para llenar la información de recepción",
    邮箱: "Correo electrónico",
    省份: "省份",
    州: "Estado",
    请选择省份: "请选择省份",
    请选择州: "Elija estado",
    城市: "Ciudad",
    市: "Ciudad",
    请选择城市: "Elija ciudad",
    乡镇: "Colonia",
    请选择乡镇: "Por favor selecciona una ciudad",
    街道: "街道",
    请输入街道: "请输入街道",
    支付方式: "支付方式",
    "体积(CM)": "体积(CM)",
    体积: "体积(CM)",
    信息查询: "信息查询",
    运单号不能为空: "La guía de rastreo no puede estar vacía",
    查询: "Buscar",
    寄件地址簿: "Dirección de envío",
    收件地址簿: "Direccion de destino",
    手机: "Numero telefónico",
    地址: "Dirección",
    联系人: "Nombre",
    选择联系人: "Seleccione la dirección",
    现金: "现金",
    长: "长",
    宽: "宽",
    高: "高",
    "以上运费不含燃油附加费和增值税，具体标准以当地门店的标准为准":
      "El flete anterior no incluye recargo por combustible ni impuesto al valor añadido. El estándar específico está sujeto al estándar de la tienda local.",
    未查询到运费金额: "No se puede buscar la cantidad total, por favor contáctenos en la línea de ayuda para revisar.",
    保存: "Guardar",
    预估运费: "预估运费",
    单边长度不超过158cm: "La longitud de ningún lado debe exceder los 158 cm.",
    长宽高三边长度之和不超274cm: "La suma de largo, ancho y alto no debe exceder los 274 cm.",
    "勾选体积时，长宽高皆不可为空": "勾选体积时，长宽高皆不可为空",
    "0＜重量≤30KG，1位小数": "0＜weight ≤30KG，1 decimales",
    长度不超过20个字符: "长度不超过20个字符",
    长度不超过30个字符: "长度不超过30个字符",
    长度不超过50个字符: "长度不超过50个字符",
    长度不超过200个字符: "长度不超过200个字符",
    请输入正确的邮箱: "Ingrese una direccción de correo electrónico válida",
    请输入正确的手机号: "Por favor ingresa un número telefonico válido",
    请选择支付方式: "Elija modo de pago",
    请选择结算方式: "Seleccione el método de pago",
    确认修改: "Confirmar",
    公司名称: "Nombre de la compañia",
    请输入公司名称: "Favor de ingresar el nombre de la compañia",
    邮编: "Código Postal",
    请输入邮编: "ingrese el código postal",
    请输入邮编获取: "Por favor ingrese el código postal",
    "净重(kg)": "Peso neto",
    "包裹重(kg)": "Peso del paquete",
    结算方式说明: "PP_CASH：Pago en recepción；<br>CC_CASH：Pago contra entrega；<br>PP_PM：Pago mensual",
  },
  networkSelect: {
    请输入邮编: "Digite seu CEP",
    服务网点: "Franquias",
    查询: "Buscar",
    暂无数据: "Sem dados",
    导航: "Navegação",
    收件网点: "coleta",
    运单费用: "Tarifas de envío",
    派件网点: "entrega",
    总条数Msg: "Se han encontrado {} puntos de venta",
    "州/市": "Estado/Ciudad",
    "网点正在努力开发中！": "¡El sitio está en desarrollo!",
    请输入有效邮编: "Digite seu CEP",
    "您检索的邮编可能有误，验证后重试。": "El código postal que ha recuperado puede ser incorrecto, verifíquelo e inténtelo de nuevo.",
  },
  pagePublicServe: {
    info: `Oferece serviços de coleta e entrega porta-a-porta padrão para você entregar pacotes de 0 a 30 quilos em todo o país. Fornecemos também soluções logísticas integradas.`,
    expressDeliveryService:
      "A J&T Express oferece a você um serviço de entrega expressa 7×24 horas e 365 dias para atender às suas necessidades a qualquer hora e em qualquer lugar.",
    "365DaysService": "365 DIAS DE SERVIÇO",
    "24HOURS": "7×24 HORAS",
    FastResponse: "Conforme a necessidade dos clientes, de imediato a J&T Express providenciará as melhores soluções.",
    PersonalizedServices:
      "Para clientes VIP mais exigentes quanto à robustez de sua segurança e imediatez de atendimento, a J&T Express fornecerá soluções customizadas através do serviço de soluções VIP, deixando o cliente livre de preocupações.",
    VipService: "SERVIÇO VIP",
    personalized: "PERSONALIZADO",
    customized: "CUSTOMIZADO",
    TraceTrack: "Através do website J&T Express e no APP, o cliente pode acompanhar toda a trajetória da entrega.",
    "E-commercePartners":
      "A J&T Express estabeleceu parcerias com as principais plataformas de comércio eletrônico do país para fornecer serviços logísticos seguros e confiáveis aos clientes de comércio eletrônico.",
  },
  "365 DAYS OF OPERATION": "365 DIAS DE OPERAÇÃO",
  "FAST RESPONSE": "RESPOSTA RÁPIDA",
  "PERSONALIZED SERVICES": "SERVIÇOS PERSONALIZADOS",
  "TRACE & TRACK": "CONSULTAS EM TEMPO REAL",
  "E-commerce Partners": "PARCEIROS DE COMÉRCIO ELETRÔNICO",
  "About Us": "Sobre nós",
  "Who Are We": "Quem somos nós",
  "WHO ARE WE": "QUEM SOMOS NÓS",
  "Business Culture": "Cultura empresarial",
  "BUSINESS CULTURE": "CULTURA EMPRESARIAL",
  "Brand Strength": "Força da marca",
  "BRAND STRENGTH": "FORÇA DA MARCA",
  "Brand History": "História da marca",
  "BRAND HISTORY": "HISTÓRIA DA MARCA",
  Mission: "Missão",
  Vision: "Visão",
  "Core Values": "Valores",
  pageAboutUs: {
    WhoAreWe: `A J&T Express é uma empresa Global de serviços expressos com base na Internet, com  enfoque em inovação tecnológica. A J&T está empenhada em criar continuamente a melhor experiência em logística e entrega expressa para seus clientes, de forma a se tornar um prestador de serviço compreensivo de logística em que os clientes possam confiar.`,
    Mission: "O cliente como o núcleo, a eficiência como raiz",
    Vision: "Manter-se, no longo prazo, como uma empresa auto-sustentável",
    Core: `<i>Benfen</i>, colaboração e responsabilidade`,
    BrandStrength_one:
      "Os negócios da J&T Express envolvem diversos campos, tais como entrega expressa, as entregas de grande porte, estocagem de bens e cadeias de suprimentos. A área de atuação do negócio se estende aos níveis intermunicipais e internacionais. A rede de serviços de entrega expressa da J&T Express, cobre 13 países e atinge 2,5 bilhões de pessoas a redor do mundo.",
    BrandStrength:
      "A empresa conta com mais de 240 centros de tranferência de larga escala, 1.000 equipamentos de triagem inteligente, 1.000 veículos próprios, 23.000 pontos de vendas e 400.000 colabora-dores.",
    BrandHistory: `A J&T Express foi fundada no ano de 2015. Atualmente, a nossa rede de prestação de serviços cobre 13 países ao redor do mundo. Todos os dias fornecemos aos clientes serviços de entrega expressa de excelente qualidade e eficiência, altamente confiáveis, fazendo com que mais clientes aproveitem os benefícios trazidos pela transformação digital da economia.`,
  },
  "June 2021": "Junho de 2021",
  "J&T Express USE, Saudi Arabia, Brazil, Mexico, Egypt officially launched": "J&T Express EAU, Arábia Saudita, Brasil, México, Egito em preparação",
  "March 2020": "Março de 2020",
  "J&T Express China officially established": "Inauguramos oficialmente J&T Express China",
  "January 2020": "Janeiro de 2020",
  "J&T Express Singapore officially established": "Inauguramos oficialmente J&T Express Singapura",
  "October 2019": "Outubro de 2019",
  "J&T Express Cambodia officially established": "Inauguramos oficialmente J&T Express Camboja",
  "March 2019": "Março de 2019",
  "J&T Express Thailand was officially established": "Inauguramos oficialmente J&T Express Tailândia",
  "J&T Express Philippines officially established": "Inauguramos oficialmente J&T Express Filipinas",
  "August 2018": "Agosto de 2018",
  "J&T Express Malaysia officially established": "Inauguramos oficialmente J&T Express Malásia",
  "July 2018": "Julho de 2018",
  "J&T Express Vietnam officially established": "Inauguramos oficialmente J&T Express Vietnã",
  "October 2017": "Outubro de 2017",
  October2017History: `Foi realizada a conferência estratégica "Express Your Online Business", marcando a entrada do Grupo J&T na era da entrega expressa de comércio eletrônico`,
  "August 2015": "Agosto 2015",
  "J&T Express Indonesia officially established": "Inauguramos oficialmente J&T Express Indonésia",
  "JOIN US": "TRABALHE CONOSCO",
  joinUsInfo: `Talento é o bem mais precioso que possui a J&T Express, sendo a base de seus valores fundamentais. Tais valores levam J&T Express a cultivar a atmosfera cultural de “Juntos, o nosso futuro”, incentivando a colaboração interna, fornecendo um ambiente de trabalho equitativo, diversificado, integrado e inclusivo, com irrestrito respeito e sem discriminação de gênero, nacionalidade, etnia e crença religiosa. Através de um exigente sistema de treinamento e um sistema de sociedade exclusivo, a J&T Express propõe, como caminho para o futuro, um plano de desenvolvimento de carreira a seus colaboradores.`,
  "EXPLORE POSITIONS": "CARGO PRETENDIDO",
  "More great jobs coming soon…": "Mais ótimos trabalhos em breve ...",
  "RECRUITMENT E-MAIL": "E-MAIL DO CANDIDATO",
  pageTrajectoryQuery: {
    单号列表: "Lista de números de carta de porte",
    运单信息: "Informação da carta de porte",
    无效运单号: "Número de carta de porte inválido",
    运单号Msg:
      "Msg do número da carta de porte: Desculpe, as informações desta carta de porte {} não foram encontradas. Confirme se o número da carta de porte está correto",
    存在非法运单号: "Existe número de carta de porte ilegal",
    查询: "Consultar",
    运单列表: "Lista da carta de porte",
    运单详情: "Detalhes da carta de porte",
    快件跟踪: "Rastreamento da carta de porte",
    运单号不能为空: "O número da carta de porte não pode estar vazio",
    运单号: "Número de carta de porte",
    街道: "街道",
    只支持查询1条运单号: "Suporta apenas uma consulta de número de carta de porte",
    单次最多查询10条运单号: "Um máximo de 10 números de carta de porte podem ser consultados uma vez",
    searchPlaceholder2: "Digite o número da carta de porte para consulta, separe com vírgula e ponto e vírgula, o máximo de consulta é 10 uma vez",
    安全提醒:
      "Alerta de segurança: a J&T Express não solicita pagamento de taxas alfandegárias por WhatsApp/SMS/links de terceiros para a entrega do seu pacote. Para qualquer cobrança ou atualização de entrega, utilize apenas os canais oficiais da J&T Express",
    收件人信息确认: "Confirmação de Informações do Destinatário",
    "收件人CNPJ/CPF": "CPF/CNPJ do Destinatário",
    收件人CEP: "CEP do Destinatário",
    校验: "Validação",
    "请输入收寄件人CPF/CNPJ": "Insira o CPF/CNPJ do remetente/destinatário.",
  },
  信息: "Informação",
  隐私政策: "PolÍtica De Privacidade",
  关注我们: "SIGA-NÓS",
  其他市场官网: "Site Oficial de outros mercados",
  "关于 J&T EXPRESS": "SOBRE A J&T",
  中国大陆: "China continental",
  中国香港: "Hong Kong, China",
  印度尼西亚: "Indonésia",
  马来西亚: "Malásia",
  菲律宾: "Filipinas",
  新加坡: "Singapura",
  柬埔寨: "Camboja",
  泰国: "Tailândia",
  越南: "Vietnã",
  沙特阿拉伯: "Arábia Saudita",
  阿拉伯联合酋长国: "EAU",
  墨西哥: "México",
  埃及: "Egito",
  营业时间: "HORARIO DE ATENDIMENTO",
  "上午8:00 - 晚上6:00": "8h às 18h",
  "周一至周四  —— 08h - 18h": "Segunda à Quinta —— 08h - 18h",
  "周五至周六  —— 08h - 17h": "Sexta e Sábado —— 08h - 17h",
  预计签收时间: "Data prevista de entrega",
  查看图片: "Visualizar Imagem",
  预览图片: "Pré-visualizar Imagem",
  网点类型: "Tipo de ramo",
  收件网点: "coleta",
  派件网点: "entrega",
  "在这里模拟您的配送，找到运往巴西各地的最佳运费": "Descubra os melhores preços de frete para qualquer canto do Brasil, simulando seus envios aqui!",
  始发地邮编: "CEP de Origem",
  目的地邮编: "CEP de Destino",
  高: "Altura",
  宽: "Largura",
  长: "Comprimento",
  重量: "Peso",
  货物价值: "Valor",
  计算运费: "Calcular Frete",
  清空: "Voltar",
  寄件网点: "Ponto de Coleta",
  "仅供参考，根据实际情况可能会有变动": "Apenas para referência, sujeito a alterações de acordo com a situadção real",
  最大30公斤: "Máx. 30kg",
  无效邮编: "O cep é inválido",
  含税金额: "Incluindo Impostos",

  登录: "Login",
  注册: "Cadastrar",
  退出登录: "Sair",
  输入您的电子邮件或电话号码: "Insira seu e-mail ou número de telefone",
  请输入密码: "Por favor, insira a senha",
  立即注册: "Cadastrar agora",
  忘记密码: "Esqueci a senha ",
  登录成功: "Login bem-sucedido",
  姓名: "Nome",
  电话: "Telefone",
  验证码已通过电子邮件发送: "O código de verificação foi enviado por e-mail",
  验证码: "Código de verificação",
  获取验证码: "Enviar código",
  密码: "Senha",
  确认密码: "Confirmar senha",
  确认: "Confirmar",
  "已有账号，去登录": "Já tem uma conta? Entrar",
  我已阅读并接受: "Já li e concordo",
  使用条款: "Termos de uso",
  隐私协议: "PolÍtica De Privacidade",
  "密码格式为6~16位大小写字母加数字": "A senha deve ter entre 6 a 16 caracteres, incluindo letras maiúsculas, minúsculas e números",
  密码不一致: "As senhas não coincidem",
  邮箱格式不正确: "Formato de e-mail incorreto",
  请输入姓名: "Por favor, insira o nome",
  请输入电话号码: "Por favor, insira o número do telefone",
  请输入CPF或CNPJ: "Por favor, insira o CPF ou CNPJ",
  CPF或CNPJ: "CPF ou CNPJ",
  请输入验证码: "Por favor, insira o código de verificação",
  长度在8到14位: "O comprimento deve ser entre 8 a 14 caracteres",
  注册成功: "Cadastro bem-sucedido",
  找回密码: "Recuperar senha",
  请输入您的邮箱: "Por favor, insira o seu e-mail",
  再次输入密码: "Digite a senha novamente",
  密码修改成功: "Senha alterada com sucesso",
  手机号: "Número de telefone",
  邮箱: "E-mail",
  请输入邮箱: "Por favor, insira o e-mail",
  和: " e ",
  我要寄件: "Enviar",
  运费查询: "Simular frete",
  轨迹查询: "Rastrear",
  我的订单: "Lista de pedidos",
  订单列表: "Lista de pedidos",
  联系客服: "Falar com um atendente",
  我的数据: "Meus dados",
  清除数据: "Limpar dados",
  "%天送达": "Entregue em % dias",
  预测: "Previsão",
  将于以下日期到达: "Chegará dia",
  发送: "Enviar",
  返回: "Voltar",
  欢迎: "Bem-vindo",
  下单日期: "Data",
  订单号: "Pedido",
  运单号: "Remessa",
  运费: "Valor",
  订单状态: "Status",
  面单: "Etiqueta",
  点击下载: "Clique para baixar",
  下载中: "Baixando",
  物品金额: "Valor do item",
  立即下单: "Criar pedido agora",
  物品信息: "Informações do item",
  物品名称: "Nome do item",
  请输入物品名称: "Por favor, insira o nome do item",
  本人声明此处描述的所有内容均属真实: "Declaro que todas as informações descritas aqui são verdadeiras",
  寄件人: "Remetente",
  "请输入CNPJ/CPF": "Por favor, insira o CNPJ/CPF",
  寄件人姓名: "Nome do remetente",
  请输入寄件人姓名: "Por favor, insira o nome do remetente",
  请输入手机号: "Por favor, insira o número de celular",
  请输入电话: "Por favor, insira o número de telefone",
  邮编: "CEP",
  请输入邮编: "Por favor, insira o CEP",
  详细地址: "Complemento",
  请输入详细地址: "Por favor, insira o Complemento",
  街道号: "Número",
  请输入街道号: "Por favor, insira o número da rua",
  街道: "Logradouro",
  请输入街道: "Por favor, insira o logradouro",
  区: "Bairro",
  省: "Estado",
  市: "Cidade",
  请输入IE: "Por favor, insira o IE",
  选择取件网点: "Selecione o ponto de coleta",
  取件网点名称: "Nome do ponto de coleta",
  收件人: "Destinatário",
  确定: "Confirmar",
  请输入高: "Por favor, insira a altura",
  请输入宽: "Por favor, insira a largura",
  请输入长: "Por favor, insira o comprimento",
  请输入重量: "Por favor, insira o peso",
  请输入货物价值: "Por favor, insira o valor do item",
  请输入邮编获取省市区: "Insira um CEP válido",
  "长度为11-14位": "Comprimento deve ter de 11 a 14 caracteres",
  "长度为8-14位": "Comprimento deve ter de 8 a 14 caracteres",
  长度为8位: "Comprimento deve ter 8 caracteres",
  "长度为2-200位": "Comprimento deve ter de 2 a 200 caracteres",
  请选择取件网点: "Por favor, selecione o ponto de coleta",
  订单已确认: "Pedido confirmado",
  "您的面单将通过电子邮件发送，附带邮寄指南。": "A sua etiqueta será enviada por e-mail junto com as orientações para a postagem.",
  订单详情: "Detalhes do pedido",
  继续下单: "Continuar criando pedido",
  在搜索栏中输入邮编查询: "Insira o CEP na campo de pesquisa",
  搜索: "Pesquisar",
  距离: "Distância",
  选择: "Escolher",
  收件人姓名: "Nome do destinatário",
  请输入收件人姓名: "Insira o nome do destinatário",
  电话号码格式不正确: "Formato número de telefone incorreto",
  轨迹跟踪: "Rastreio",
  查看全部: "Ver tudo",
  详情: "pedido",
  ies: {
    国际运输服务: " Remessa Expressa<br/> Internacional",
    提供全程追踪服务: "Soluções Inteligentes e Econômicas de Entrega Internacional ",
    智能且高性价比的国际运输解决方案: "com rastreamento completo em todas as etapas!",
    简介: "Estamos aqui para simplificar suas operações de remessas cross-border para o Brasil! Com soluções completas e acessíveis, você pode esquecer as preocupações com burocracia e prazos. Contamos com soluções flexíveis e ajustáveis à suas necessidades, desde a logística completa “door to door” ou customizadas por etapas:",
    为什么: "Por que escolher a J&T para seus envios internacionais?",
    便捷: "Simplicidade: ",
    便捷说明: "Eliminamos a complexidade, lidando com todos os detalhes para você.",
    经济: "Economia: ",
    经济说明: "Nossas soluções são inteligentes e econômicas, poupando seu tempo e dinheiro.",
    可靠: "Confiabilidade: ",
    可靠说明: "Conte com nossa experiência para garantir que suas remessas cheguem ao destino sem problemas.",
    我们为您的业务提供多种解决方案: "Oferecemos diversas soluções<br/> para os seus negócios.",
    我们的专业领域: "Nossas áreas de atuação:",
    了解更多: "saiba mais",
    电子商务: "e-commerce",
    电子商务说明开头: "Conte com nossa experiência",
    电子商务说明:
      " para enviar e receber os produtos para o seu e-commerce. Através de nossa rede própria e de parceiros em todo o mundo, cuidaremos de todo o processo para você. Desde a coleta do seu pedido até o embarque para o Brasil, passando pelo desembaraço aduaneiro, nós cuidamos de cada etapa. Isso significa que você pode deixar a burocracia por nossa conta e terá mais tempo para focar em suas vendas e no crescimento do seu negócio. Simplificamos a logística para que você possa alcançar novos patamares de sucesso no mundo do comércio eletrônico.",
    国际货物运输: "Remessas<br/> Internacionais",
    国际货物运输说明开头: "Na J&T Express Courier",
    国际货物运输说明:
      " estamos comprometidos em tornar a importação de bens mais simples e eficientes para você. Nossos serviços de remessas internacionais são projetados especificamente para atender às suas necessidades de importação, com um foco especial no courier, oferecendo Rapidez, confiabilidade, conformidade com a legislação, transparência, rastreabilidade, economizando tempo e dinheiro.",
    货物合规运输计划: "Programa Remessa Conforme (PRC)",
    货物合规运输计划1: "Programa Remessa Conforme (PRC)",
    货物合规运输计划说明开头: "A certificação no Programa Remessa Conforme (PRC) ",
    货物合规运输计划说明:
      "da Receita Federal permite à empresa de comércio eletrônico obter benefícios tributários e aduaneiros para as mercadorias que comercializa e que são enviadas para o Brasil por meio de remessas internacionais amparadas pelo Regime de Tributação Simplificada. Os benefícios incluem a redução da alíquota do Imposto de Importação, que passa de 60% para 20% nas compras internacionais destinadas a pessoas físicas, para bens de remessa com valor até 50 dólares (ou o equivalente em outra moeda). Também há priorização dessas remessas no despacho aduaneiro.",
    更多: "Para mais detalhes, ",
    请访问: "acesse o Portal: ",
    客服: "Ainda ficou com dívidas? Entre em contato com a Central de Ajuda J&T Express, que teremos o prazer em auxiliar.",
    样品寄送: "Amostras",
    样品寄送说明开头: "Se você precisa enviar ou receber amostras ",
    样品寄送说明:
      "de produtos de clientes ou parceiros do exterior, estamos aqui para tornar o processo fácil e econômico. Nossos serviços de remessa internacional de amostras sem valor comercial garantem que suas amostras cheguem ao destino de forma rápida e segura, atendendo a todas as regulamentações alfandegárias. ",
    规则: "Regras Gerais",
    规则说明:
      "Regras:<br/>- Processo simplificado, sem necessidade de RADAR ou despachante. <br/>- Valor da mercadoria não pode exceder o limite US$ 3.000,00 (três mil dólares americanos), ou equivalente em outra moeda.<br/>- Pessoa jurídica com ou sem finalidade comercial (para os bens destinados a revenda até o limite de USD150,000.00 no ano calendário).<br/>- Pessoa física sem finalidade comercial (não é permitida a importação de bens ou encomendas em quantidade e frequência que caracterizam comércio por pessoa física).<br/>- Obrigatório informações a serem prestadas antecipadamente pelo transportador ( CPF, Nome ,endereço,e etc.), sob pena de não haver conclusão da liberação e ocorrer retorno para origem, onerando sempre o shipper. Vide Instrução Normativa RFB nº 2124, de 16 de dezembro de 2022.<br/>- Limite de peso por encomenda de 30kg.<br/>- Limites de dimensões para inspeções não invasivas: 90cm x 100cm.<br/>- Deve ser acompanhada por fatura comercial.<br/>- Manter documentos relativos à importação/exportação em boa guarda e ordem conforme determina o art. 70 da Lei 10833 de 29/12/2003.<br/>- Em caso de pendência o prazo de guarda é de até 20 dias após chegada, sob pena de devolução da mercadoria coso não ocorra a regularização.",
    征税制度: "Regime de Tributação",
    征税制度说明:
      "Regime:<br/>O Regime de Tributação Simplificada aplica alíquota única de imposto de importação (II) de 60% independentemente da classificação tarifária + ICMS do estado de residência do destinatário, aplicado sobre o valor CIF + II.Isenção de IPI, PIS e COFINS.<br/><br/>Programa Remessa Conforme: <br/>A alíquota do Imposto de Importação será aplicada somente para encomendas internacionais:<br/>-  Adquiridas de empresas de comércio eletrônico certificadas no Programa Remessa Conforme. Consulte aqui as empresas certificadas.<br/>- No valor de até US$ 50,00 (ou equivalente), o imposto de importação  será de 20%<br/>- No valor acima de US$ 50,01 (ou equivalente), o imposto de importação  será de 60% e será concedido  um desconto de US$ 20 sobre o valor do imposto calculado.<br/>- Somente para comprador pessoa física.<br/>- Com pagamento antecipado do ICMS de 17% . <br/>Para encomendas internacionais que não se enquadrem em todos os requisitos acima, a alíquota geral da tributação simplificada continua sendo de 60% (+ o ICMS do estado de residência do destinatário).<br/><br/>Medicamentos Importados por Pessoa Física<br/>O limite de valor de será de US$ 10.000,00 (dez mil dólares dos Estados Unidos da América) para a importação por pessoa física de produtos acabados pertencentes às classes de medicamentos, observados os requisitos e condições estabelecidos na Portaria MF nº 156, de 24 de junho de 1999, e o disposto no § 7º. (Redação dada pelo(a) Instrução Normativa RFB nº 2208, de 31 de julho de 2024)<br/>Caso o valor aduaneiro total da remessa a que se refere o § 6º ultrapasse o limite definido no art. 37, caput, a importação será permitida apenas se a remessa contiver exclusivamente produtos acabados pertencentes às classes de medicamentos.   (Incluído(a) pelo(a) Instrução Normativa RFB nº 2208, de 31 de julho de 2024)<br/>A liberação desses produtos está condicionada ao cumprimento dos requisitos estabelecidos pela Agência Nacional de Vigilância Sanitária (ANVISA), órgão de controle administrativo.<br/><br/>Ressalta-se que esse benefício aplica-se apenas a medicamentos destinados à pessoa física, para seu uso próprio ou individual (assim entendido como aquele importado por uma pessoa física para o tratamento de outra pessoa física, como por exemplo o de um pai importando medicação para tratamento de seu filho). O benefício não ampara importações de medicamentos destinados ao uso veterinário, suplementos e cosméticos.<br/><br/>Bagagem Desacompanhada<br/>Poderá ser dado o tratamento de bagagem desacompanhada, a requerimento do interessado, para bens contidos em encomendas internacionais vindas de país no qual tenha estado ou residido. <br/>Para ser considerada bagagem desacompanhada, a encomenda internacional deverá provir do local ou de um dos locais de estada ou de procedência do viajante e chegar ao país dentro dos 3 meses anteriores ou até os 6 meses posteriores à chegada do viajante.Os bens integrantes de bagagem desacompanhada não serão tributados nas seguintes hipóteses:<br/>- retorno de bens nacionais ou nacionalizados;<br/>- roupas e bens de uso pessoal, usados, bem como livros, folhetos e periódicos;<br/>- bens, novos ou usados, elencados no art. 35 da IN RFB nº 1.059/2010, de residentes no exterior que ingressem no país para nele residir de forma permanente, e de brasileiros que retornem ao país, provenientes do exterior, depois de lá residirem há mais de 1 ano.<br/><br/>Amostras sem valor comercial<br/>Para que essa isenção possa ser aplicada, o bem deve estar enquadrado na definição de amostra sem valor comercial, como sendo qualquer bem importado sob essa condição com a finalidade de demonstrar suas características, desprovido de todo valor comercial, seja porque não o possui, devido a sua quantidade, peso, volume ou outras condições de apresentação, seja porque foi privado desse valor mediante operações físicas de inutilização para impossibilitar a sua comercialização<br/><br/>Livros, jornais e periódicos<br/>É concedida imunidade do Imposto de Importação às importações de livros, jornais e periódicos e do papel destinado a sua impressão.<br/>Para que seja concedida a imunidade, o item deve estar enquadrado no conceito de livro do Art. 2º da Lei nº 10.753/2003, lei que instituiu a Política Nacional do Livro.",
    法律法规: "Legislação",
    法律法规说明:
      "PORTARIA MF Nº 156, DE 24 DE JUNHO DE 1999<br/>Instrução Normativa 1737 de 15 de setembro 2017<br/>Portaria COANA 81 de 17 de outubro de 2017<br/>PORTARIA MF Nº 612, DE 29 DE JUNHO DE 2023 <br/>INSTRUÇÃO NORMATIVA RFB Nº 2146, DE 29 DE JUNHO DE 2023<br/>PORTARIA COANA Nº 130, DE 25 DE JULHO DE 2023",
    违禁物品: "Itens Proibidos",
    违禁物品说明:
      "- Itens que necessitam de LI (Licenciamento de Importação)<br/>- Bebidas alcoólicas<br/>- Cigarros, cigarrilhas e charutos, de tabaco ou de seus sucedâneos<br/>- Moeda corrente (dinheiro em espécie)<br/>- Animais e vegetais da vida silvestre<br/>- Materiais usados ou recondicionados (exceto os de uso pessoal)<br/>- Armas de fogo e munição<br/>- Antiguidades e obras de arte<br/>- Produtos falsificados (de contrafação)<br/>- Materiais combustíveis ou perigosos<br/>- Diamantes (HS 7102), pedras preciosas, semipreciosas e joias<br/>- Narcóticos (drogas ilegais)<br/>- Material químico<br/>- Materiais de jogos<br/>- Partes humanas, inclusive cinzas<br/>- Outros bens cujo transporte seja proibido pelas normas da aviação civil internacional.",
  },
  请输入物品类型: "Por favor, insira o tipo de item",
  禁止运输货物清单: "Lista de Mercadorias Proibidas",
  运输限制: "Restrições de Transporte",
  "重量: 最大允许为30kg": "Peso: O máximo permitido é de 30kg",
  "高度: 允许包裹高度在1到120cm之间": "Altura: Permitidos pacotes entre 1 a 120cm",
  "宽度: 允许包裹宽度在1到120cm之间": "Largura: Permitidos pacotes entre 1 a 120cm",
  "长度: 允许包裹长度在1到120cm之间": "Comprimento: Permitidos pacotes entre 1 a 120cm ",
  三边之和不得超过240厘米: "A soma dos 3 lados não pode ultrapassar 240 cm",
  生物材料样本: "Amostras de material biológico",
  已死亡动物: "Animais mortos",
  武器和军事装备: "Armas e equipamentos militares",
  "香烟、烟草制品及类似产品": "Cigarros, produtos de tabaco e itens similares",
  腐蚀性物质: "Substâncias corrosivas",
  活生物: "Organismos vivos",
  现金: "Dinheiro",
  法律禁止的毒品: "Drogas legalmente proibidas",
  爆炸物: "Explosivos",
  珠宝和贵重石: "Joias e pedras preciosas",
  液体: "Líquidos",
  放射性物质: "Materiais radioativos",
  药物: "Produtos farmacêuticos",
  危害国家安全的物品: "Itens prejudiciais à segurança nacional",
  鸟蛋: "Ovos de pássaros",
  种子: "Sementes",
  活植物: "Plantas vivas",
  各类危险品: "Vários materiais perigosos",
  尸体: "Corpos",
  对邮政服务的风险: "Riscos aos serviços postais",
  气雾剂: "Aerossóis",
  易燃固体: "Sólidos inflamáveis",
  "易腐烂、易变质、有异味、令人作呕和有害的物质": "Substâncias perecíveis, com odor desagradável, nauseantes e nocivas",
  锂离子电池和电池: "Baterias de íon de lítio e células",
  "压缩气体、液化气体或溶解在压力下的气体": "Gases comprimidos, gases liquefeitos ou gases dissolvidos sob pressão",
  艺术品: "Obras de arte",
  氧化剂和有机过氧化物: "Oxidantes e peróxidos orgânicos",
  有毒物质和感染性物质: "Substâncias tóxicas e infecciosas",
  请输入: "Insira conteúdos válidos",
  下载: "download",
  "未获取到CT-E信息": "Informações do CT-E não obtidas",
  请输入CPF: "Por favor, insira o CPF",
  长度为11位: "O comprimento é de 11 dígitos",
  请输入CNPJ: "Por favor, insira o CNPJ",
  长度为14位: "O comprimento é de 14 dígitos",
  "CT-E 下载": "Baixar CT-E",
  输入的CPF不正确: "O CPF informado está incorreto",
  输入的CNPJ不正确: "O CNPJ informado está incorreto",
  全名: "Nome completo",
  电子邮箱: "Email",
  收货地址: "Endereço de coleta",
  产品类型: "Tipo de produto",
  每月平均订单数量: "Quantidade média de pedidos por mês",
  网站链接: "URL do site",
  推荐码: "Código de Indicação",
  仅支持数字和字母: "Apenas números e letras",
  备注: "Observações",
  请选择省市区: "Por favor, selecione estado/cidade/distrito",
  "我们为整个巴西提供配送服务，立刻送达！": "Enviamos para todo Brasil, num pulo! ",
  "想让 J&T 成为您电商的配送合作伙伴吗？ 请填写下面的表格，我们将尽快与您联系！":
    "Quer ter a J&T como parceira de entrega para o seu E-Commerce? Preencha o formulário abaixo e entraremos em contato o mais rápido possível! ",
  "我们已经收到您的信息填报，将尽快与您取得联系！":
    "Recebemos sua submissão de informações e entraremos em contato com você o mais rápido possível! ",
  "登录之后才能操作！": "Por favor, realize a operação após fazer login！",
  限制100字符以内: "Limite de 100 caracteres",
  "0-99999999之间的数字": "Somente números entre 0 e 99999999 são permitidos",
  限制30字符以内: "Limite de 30 caracteres",
  限制200字符以内: "Limite de 200 caracteres",
  限制500字符以内: "Limite de 500 caracteres",
  "我想通过 WhatsApp 接收有关我的订单的最新信息": "Gostaria de receber atualizações sobre meu pedido via WhatsApp.",
  我同意接收实时讯息和促销活动: "Eu concordo em receber mensagens em tempo real e promoções",
  修改密码: "alterar Senha",
  最喜欢的网点: "Meus endereços favoritos",
  请输入旧密码: "Insira senha antiga",
  请输入新密码: "Insira nova senha",
  "密码必须包含大小写字母，数字及特殊字母其中三种，位数限制8-20位":
    "Por favor, crie uma senha com 8 a 20 caracteres que inclua pelo menos três destes elementos: letras maiúsculas, letras minúsculas, números e símbolos especiais.",
  确认更改: "Confirmar alteração",
  "修改成功，请重新登录": "Alteração bem sucedida, por favor faça o login novamente",
  网点更新成功: "Atualização bem-sucedida",
  选择最喜欢的网点: "Escolha seu ponto de venda favorito",
  地址管理: "Endereços Favoritos",
  新增: "Adicionar",
  删除: "Excluir",
  编辑: "Editar",
  查询姓名: "Consultar Nome",
  "查询CPF/CNPJ": "Consultar CPF/CNPJ",
  新增地址簿: "Adicionar ao Endereço Favorito",
  保存: "Salvar",
  取消: "Cancelar",
  编辑地址簿: "Editar Endereço Favoritos",
  未查询到数据: "Nenhum dado encontrado",
  "请输入CPF/CNPJ": "Por favor, insira CPF/CNPJ",
  请输入电子邮箱: "Por favor, insira o e-mail",
  请输入邮政编码: "Por favor, insira o CEP",
  "请输入州/市/区": "Por favor, insira Estado/Cidade/Bairro",
  "查询到相关地址信息，确认是否自动补充": "Informações de endereço encontradas, confirmar preenchimento automático",
  温馨提示: "Aviso",
  是: "Sim",
  否: "Não",
  请确认是否删除: "Confirmar exclusão?",
  保留: "Manter",
  "州/市/区": "Estado/Cidade/Bairro",
  邮政编码: "CEP",
  请求成功: "exitosa",
  保存到地址簿: "Salvar no catálogo de endereços",
  CPF或CNPJ已存在: "CPF ou CNPJ já existe",
  长宽高总和不可超过240CM: "A soma do comprimento, largura e altura não pode exceder 240 cm",
  输入需大于1: "A entrada deve ser maior que 1",
  公司名称: "Nome da empresa",
  查件: "Consultar Encomenda",
  客户: "Clientes",
  服务支持: "Suporte ao Cliente",
  B2C服务: "B2C",
  C2C服务: "C2C",
  CBT服务: "CBT",
  联系我们: "Fale Conosco",
  客户案例: "Casos de Clientes",
  客户专享: "Benefícios Exclusivos",
  企业文化: "Cultura Empresarial",
  发展历史: "Sobre a J&T Express",
  订单反馈: "Feedback de Pedidos",
  环保反馈: "Sustentabilidade",
  成为司机: "Seja um Entregador",
  招聘信息: "Trabalhe Conosco",
  服务网点: "Pontos de Atendimento",
  输入您的电子邮件或手机号: "Digite seu e-mail ou número de telefone",
  寄件单号列表: "Lista de números de rastreamento",
  收件单号列表: "Lista de números de recibo",
  "如果需要查询详细轨迹，请输入CPF/CNPJ": "Caso necessite consultar trilhas detalhadas, informe CPF/CNPJ",
  请对您遇到的问题进行描述: "Por favor, descreva o problema que você está enfrentando",
  请输入反馈信息: "Por favor, insira suas informações de feedback",
  "请输入运单号、发票密钥或客户订单号，使用逗号或分号分隔，最多可输入30个，且不支持混合查询":
    "Insira nº do conhecimento, chave da fatura ou nº do pedido, separados por vírgulas/ponto e vírgula, máx. 30. Sem consultas mistas.",
  "对不起，没有查询到相关轨迹，请核实": "Desculpe, não encontramos nenhuma informação de rastreamento. Por favor, verifique.",
  "此为巴西本地数据，截止日期为01/12/2024": "Dados locais do Brasil, em 01/12/2024",
  "相关信息，将通过邮件发送给您。": "As informações relevantes serão enviadas a você por e-mail.",
  下载集成手册: "Manual de Download",
  使用物品申明创建订单: "Criar pedido com declaração de itens",
  点击下载表格模版: "Clique para baixar o modelo da tabela",
  点击上传表格: "Clique para fazer upload da tabela",
  使用发票创建订单: "Criar pedido com nota fiscal",
  批量选择XML发票文件: "Selecionar arquivos XML de nota fiscal em massa	Bulk",
  每次最多可上传30条数据: "Até 30 itens podem ser enviados por vez	Up to",
  文件解析失败: "Falha na análise do arquivo",
  文件解析成功: "Arquivo analisado com sucesso",
  查看详情: "Ver detalhes",
  批量导入: "Importação em massa",
  XML文件解析失败: "alha na análise do arquivo XML",
  客户订单编号: "Número do pedido do cliente",
  操作: "Operação",
  上传: "Enviar",
  上传成功: "Envio bem-sucedido",
  上传失败: "Falha no envio",
  状态: "Status",
  选择网点: "Selecionar unidade",
  网点名称: "Nome da unidade",
  "仅勾选的订单会被下单，未勾选的订单将被移除，请确认。":
    "Apenas os pedidos selecionados serão confirmados; os não selecionados serão removidos. Confirme, por favor.",
  重新上传: "Enviar novamente",
  下单: "Pedir",
  暂无数据: "Sem dados",
  "文件上传中...": "Carregando arquivos... ({count} selecionados)",
  请选择订单: "Por favor, selecione os pedidos",
  成为VIP: "Seja VIP",
  "无论是小型还是中型企业家，您都应该拥有一个能够增强您业务的系统":
    "Seja você um pequeno ou médio empresário, você deve ter um sistema que impulsione seu negócio",
  "更快、更高效的运输": "Entrega mais rápida e eficiente",
  节省时间并赢得客户: "Ganhe tempo e conquiste clientes",
  完全自主: "Totalmente autônomo",
  "轻松、无复杂性地管理您的订单": "Gerencie seus pedidos com facilidade, sem complicações",
  智能控制: "Controle inteligente",
  "查看您的销售情况、跟踪发货并优化您的结果": "Acompanhe suas vendas, rastreie envios e otimize seus resultados",
  什么是VIP: "O que é VIP",
  "VIP系统是一款专为中小型企业主开发的平台，专注于简化订单与销售管理。 它提供以下功能：":
    "O Sistema VIP é uma plataforma desenvolvida especialmente para pequenos e médios empreendedores, focada em facilitar o gerenciamento de encomendas e vendas. Ele oferece:",
  高效管理: "Gestão eficiente",
  一站式全面掌控所有订单: "Controle completo dos pedidos em um só lugar",
  快速定制化发货: "Envios rápidos e personalizados",
  "优化流程，精准满足客户需求": "Processos otimizados para atender às necessidades dos clientes",
  自主管理权限: "Autonomia no gerenciamento",
  "简洁实用的工具，全程跟踪从下单到交付的每个环节": "Ferramentas simples e práticas para acompanhar cada etapa, desde o pedido até a entrega",
  数据报告与分析: "Relatórios e insights",
  "直观查看业务表现，助力战略决策": "Visualize o desempenho e tome decisões estratégicas",
  VIP提供哪些服务: "Quais serviços o VIP oferece",
  存储数据: "Armazenamento de dados",
  系统注册: "Cadastro no sistema",
  系统: "Sistema",
  管理已发送的订单: "Gerenciamento de pedidos enviados",
  运输类型: "Tipos de transporte",
  权限分配: "Distribuição de permissões",
  运费报价: "Cotação de frete",
  "立即联系我们，迈出成功的下一步！": "Entre em contato conosco agora e dê o próximo passo para o sucesso!",
  成为客户: "Torne-se um cliente",
  售后管理: "Gerenciar pós-venda",
  问题反馈: "Reportar um problema",
  查询: "Consulta",
  输入运单号: "Inserir Número de Rastreamento",
  提交日期: "Data de Envio",
  问题描述: "Descrição do Problema",
  处理结果: "Resultado do Processamento",
  请输入问题描述: "Por Favor, Insira a Descrição do Problema",
  提交: "Enviar",
  查看问题: "Ver Problema",
  处理中: "Em Processamento",
  已完结: "Concluído",
  "Come on Join Us！": "Vamos! Junte-se a Nós!",
  请支付: "Por favor, pague",
  请选择支付方式: "Por favor, selecione a forma de pagamento",
  Pix支付: "Pagamento via Pix",
  信用卡: "Cartão de crédito",
  "剩余时间：x秒": "Tempo restante: {count} segundos",
  使用扫码支付: "Pagar via leitor de QR code",
  复制二维码code: "Copiar código QR",
  完成支付: "Finalizar pagamento",
  请填写支付信息: "Preencha os dados do pagamento",
  卡号: "Número do cartão",
  持卡人姓名: "Nome do titular do cartão",
  CVV码: "Código CVV",
  "有效期MM/YYYY": "Validade MM/AAAA",
  选择日期: "Selecionar data",
  完成付款: "Finalizar pagamento",
  开始日期: "Data de início",
  结束日期: "Data de término",
  输入收件人姓名: "Insira o nome do destinatário",
  支付状态: "Status do pagamento",
  待支付: "Pagamento pendente",
  已支付: "Pago",
  信用卡预授权成功: "Pré-autorização de cartão bem-sucedida",
  信用卡授权成功: "Autorização de cartão bem-sucedida",
  待客户寄件: "Aguardando envio do cliente",
  附件下载: "Baixar anexo",
  支付: "Pagamento",
  取消订单: "Cancelar Pedido",
  取消订单您需要知晓: "Ao cancelar o pedido, você precisa saber:",
  "取消后，订单将无法寄出。": "Após o cancelamento, o pedido não poderá ser enviado.",
  使用Pix支付: "Pagamento via Pix",
  退款处理时间最长为7个工作日: "O reembolso pode levar até 7 dias úteis para ser processado.",
  退款账户必须与付款时使用的账户姓名一致: "A conta de reembolso deve estar no mesmo nome do pagador.",
  信用卡支付: "Pagamento com Cartão de Crédito",
  将实时的取消授权支付: "A autorização de pagamento será cancelada imediatamente.",
  二维码已过期: "QR Code Expirado",
  复制成功: "Copiado com sucesso",
  "支付失败，如您确认完成支付请重新点击完成支付，获取支付状态，如有疑问请联系：客服":
    'O pagamento falhou. Se você confirmar que o pagamento foi concluído, clique em "Concluir pagamento" novamente para obter o status do pagamento. Caso tenha alguma dúvida, entre em contato com: Atendimento ao Cliente',
  请输入卡号: "Por favor, insira o número do seu cartão",
  请输入CVV码: "Por favor, insira o código CVV",
  请选择日期: "Por favor selecione a data",
  输入需大于0: "Valor deve ser > 0",
  有效期至: "Validade até",
  快过期: "Expirando em breve",
  去使用: "Usar agora",
  我的优惠券: "Meus cupons",
  "还没有优惠券哦，快去领取吧～": "Você ainda não tem cupons. Resgate um agora! ",
  优惠信息: "Informações da oferta ",
  优惠券编码: "Código do cupom",
  优惠券金额: "Valor do cupom",
  具体费用以实际网点为准: "Os custos finais estão sujeitos à confirmação na loja física. ",
  选择优惠券: "Selecionar cupom",
  活动描述: "Descrição da promoção",
  活动时间: "Período da promoção",
  立即领取: "Resgatar agora ",
  "领取成功！优惠券已存入您的账户，快去使用吧~": "Resgate bem-sucedido! O cupom foi adicionado à sua conta. Vá usá-lo agora!",
  热门活动: "Atividades populares",
  打卡得: "Ganhe ",
  胡萝卜: "cenouras",
  "点击可喂食MaoMao～": "Clique para alimentar MaoMao~",
  去试试: "Experimentar",
  寄快递: "Enviar pedido",
  批量寄: "Entrega em lote",
  运单查询: "Consultar pedido",
  我的资料: "Minhas informações",
  "MaoMao Pet": "MaoMao Pet",
  请输入优惠券名称: "Por favor, insira o nome do cupom",
  优惠券已关联活动无法编辑或删除: "Este cupom está vinculado a uma atividade e não pode ser editado ou excluído",
  "是否确认修改?": "Confirmar alterações?",
  优惠券名称已存在: "O nome do cupom já existe",
  请输入活动名称: "Por favor, insira o nome da atividade",
  "请输入1~99的数值": "Insira um valor entre 1 e 99",
  "最大数值为7位整数+2位小数,最小值为1": "Valor máximo: 7 dígitos inteiros + 2 casas decimais; Valor mínimo: 1",
  请选择优惠券: "Selecione um cupom",
  领取数: "Quantidade resgatada",
  核销数: "Quantidade utilizada",
  未核销数: "Quantidade não utilizada",
  活动进行中或已结束不可删除: "Não é possível excluir: Atividade em andamento ou finalizada",
  活动进行中或已结束不可编辑: "Não é possível editar: Atividade em andamento ou finalizada",
  相关活动名称: "Nome da atividade relacionada",
  待核销: "Pendente de uso",
  已核销: "Utilizado",
  优惠券使用明细导出: "Exportar detalhes de uso do cupom",
  "暂无活动，尽情期待~": "Nenhuma atividade no momento, aguarde novidades!",
  工作日: "Dia útil",
  休息日: "Dia de descanso",

  更多操作: "Mais Ações",
  注销账号: "Cancelar Conta",
  注销协议: "Contrato de Cancelamento de Registro",
  重要提醒: "Aviso Importante",
  "您是否确定注销账号并同意放弃账号绑定的相关数据及资产？确定后您的账户会立即完成注销。":
    "Tem certeza de que deseja cancelar sua conta e concorda em perder todos os dados e ativos associados? Sua conta será cancelada imediatamente após a confirmação.",
  "我已阅读并同意《注销协议》": "Li e concordo com o Contrato de Cancelamento de Registro.",
  下一步: "Próximo Passo",
  是否确定注销账号: "Tem certeza de que deseja cancelar sua conta?",
  "您的账号在注销后将无法访问、无法恢复并永久关闭": "Após o cancelamento, sua conta ficará inacessível, irrecuperável e permanentemente encerrada.",
  预制面单无法使用优惠券: "Cupom indisponível para pré-waybill",
  预制面单号: "Número da etiqueta pré-gerada",
  操作指引: "Instruções de operação",
  "填写条形码下面的编号哦~": "Preencha o número abaixo do código de barras.",
  控制您的隐私: "Controle sua privacidade",
  "我们的网站使用cookie来改善导航。": "Nosso site utiliza cookies para melhorar a navegação.",
  拒绝: "Recusar",
  接受: "Aceitar",
  活动即将开始: "A atividade está prestes a começar.",
  "J&T Express巴西公司保留本次活动的最终解释权。": "A J&T Express Brasil reserva-se o direito de interpretação final desta atividade. ",
  "详见《优惠券活动通用条款》。": 'Consulte os "Termos Gerais de Atividades com Cupons".',
  模版更新时间: "Atualização do modelo",
  订单: "Pedido",
  钱包: "Carteira",
  充值: "Recarregar",
  钱包流水: "Histórico da carteira",
  科目: "Categoria",
  暂无交易记录: "Nenhuma transação",
  金额设置: "Definir valor",
  请输入充值金额: "Insira o valor da recarga",
  支付方式: "Método de pagamento",
  取消付款: "Cancelar pagamento",
  "输入范围1~2000": "Intervalo: 1–2000",
  钱包支付: "Pagamento com carteira",
  交易后金额: "Valor após transação",
  全部: "Todos",
  散单运单运费: "Frete de envio avulso",
  运费补差价: "Diferença de frete",
  钱包充值: "Recarregar carteira",
  退运费: "Reembolso de frete",
  订单取消: "Cancelamento de pedido",
  待寄件: "A enviar",
  已取件: "Coletado",
  已签收: "Entregue",
  已取消: "Cancelado",
  差额补收: "Cobrança extra",
  去支付: "Pagar agora",
  运单轨迹: "Rastreio",
  电子钱包: "Carteira eletrônica",
  使用钱包支付: "Pagar com carteira",
  当前余额: "Saldo atual",
  支付失败: "Pagamento Falhou",
  "余额不足, 请尽快充值": "Saldo insuficiente, recarregue em breve",
  我的钱包: "Minha carteira",
  时间: "Hora",
  交易金额: "Valor da transação",
  自定义金额: "Valor personalizado",
  Cookie政策: "Política de Cookies",
  运费差额补收: "Cobrança suplementar da diferença de frete",
  已支付金额: "Valor pago",
  实际称重: "Peso real",
  "余额不足，请尽快充值": "Saldo insuficiente, por favor recarregue o mais rápido possível",
  "运费未结清，请结清后下单。": "O frete não foi quitado. Por favor, pague-o antes de fazer o pedido.",
  确认使用钱包余额进行支付: "Confirmar pagamento com saldo da carteira",
  公告: "Aviso",
  紧急公告: "Aviso urgente",
  上线公告: "Aviso publicado",
  系统公告: "Aviso do sistema",
  置顶: "Fixar",
  必读: "Leitura obrigatória",
  发布时间: "Data de envio",
  暂无公告: "Sem anúncios",
  "请输入 1~100 的正整数": "Digite 1–100",
  "44位数字": "44 dígitos",
  最大3位数字: "Máx. 3 dígitos",
  "最大9999999.99的数字": "Máx. 9.999.999,99",
  NCM编码: "Código NCM",
  物品单价: "Unitário",
  请输入物品单价: "Digite preço",
  物品数量: "Quantidade",
  请输入物品数量: "Digite quantidade",
  物品总金额: "Valor total",
  请输入物品总金额: "Digite valor total",
  "DC-e密钥": "Chave DC-e",
  "请输入DC-e密钥": "Digite chave DC-e",
  序列号: "Nº de série",
  请输入序列号: "Digite nº de série",
  金额: "Valor",
  请输入金额: "Digite valor",
  授权日期: "Autorização",
  请选择授权日期: "Selecione data",
  "请选择DC-e": "Selecione DC-e",
  获取失败: "Falha ao obter",
  "获取DC-e": "Obter DC-e",
  获取: "Obter",
  请输入NCM编码: "Insira o código NCM",
  物品总金额不能超过1000: "O valor total do item não pode exceder 1000",
  "DC-e 获取成功": "DC-e obtido",
  发票信息: "Informações da fatura",
  待获取: "A obter",
  优惠券: "Cupom",
  请输入有效字符: "Por favor, insira caracteres válidos.",
  成为我们的加盟商: "Seja um franqueado",
  成为我们的PUDO站点: "Seja um ponto de coleta",
  批量支付: "Pagamento em lote",
  云仓: "Fulfillment",
  JoinUs: {
    合作机会: "Oportunidade de parceria",
    您的店铺可以成为: "Sua loja pode virar um",
    极兔速递收集点: "Ponto de Coleta J&T",
    "并产生额外收入。": "e gerar renda extra.",
    零加盟费: "Zero taxa de adesão",
    零固定成本: "Custo fixo zero",
    无需库存: "Sem necessidade de estoque",
    我想成为极免速递收集点: "Quero ser um Ponto de coleta J&T",
    "提案提交成功！": "Proposta enviada com sucesso!",
    "我们已收到您成为极兔速递加盟商的意向。我们的销售团队将在48小时内与您联系，介绍完整的业务计划。":
      "Recebemos seu interesse em se tornar um franqueado J&T Express. Nossa equipe comercial entrará em contato em até 48 horas para apresentar o plano de negócio completo.",
    提交新提案: "Enviar nova proposta",
    "立即注册！": "Faça seu cadastro!",
    "填写您的详细信息，成为极兔速递收集点。": "Preencha seus dados e torne-se um ponto de coleta J&T Express.",
    姓名: "Nome",
    电子邮件: "E-mail",
    电话: "Telefone",
    营业执照号: "CNPJ",
    地址: "Endereço",
    邮编: "CEP",
    城市: "Cidade",
    州: "Estado",
    "您是否已经为其他网络工作？": "Você já atua como ponto de outras redes?",
    是: "Sim",
    否: "Não",
    提交注册: "Enviar cadastro",
    "标有 * 的字段为必填项": "Campos marcados com * são obrigatórios",
    成功合作伙伴: "Parceiros de Sucesso",
    评价: "Depoimentos",
    合作伙伴怎么说: "O que nossos parceiros dizem",
    极兔速递加盟商和合作伙伴的真实体验: "Experiências reais de franqueados e parceiros J&T Express",
    "为什么选择极兔？": "Por que escolher a J&T?",
    巴西最大的私营物流网络之一: "Uma das maiores redes privadas de logística no Brasil",
    "极免速递是巴西最大的私营物流网络之一,提供强大的基础设施来满足业多和消费者需求":
      "A J&T Express é uma das maiores redes privadas de logística no lBrasil, oferecendo uma infraestrutura robusta e eficiente para atender às demandas de negócios e consumidores ",
    主要电商平台的全球战略合作伙伴: "Parceira estratégica global das principais plataformas de e-ccommerce",
    "极兔速递是主要电商平台的全球战略合作伙伴,如Shopee和Mercado Livre,提供对广泛市场的访问和客户。":
      "A J&T Express é parceira estratégica de plataformas de e-commerceglobais como Shopee e Mercado Livre, proporcionando acesso a uma vasta gama de mercados e clienttes.",
    先进技术和持续培训推动您的业务: "Tecnologia avançada e capacitação contínua para impulsionar seu negócio",
    "极兔速递投资于先进技术,并为合作伙伴提供持续培训,帮助优化运营并提高生产力。":
      "A J&T Express investe em tecnologia avançada e oferece capacitaação contínua para seus parceiros, ajudando a otimizar operações e aumentar a produtividade.",
    独家商业机会: "Oportunidade exclusiva de negócio",
    成为: "Seja um Franqueado da",
    极兔速递: "J&T Express",
    加盟商: "Por que escolher a J&T?",
    我想成为极免速递加盟商: "Quero ser franqueado J&T",
    "表达您的兴趣！": "Manifeste seu interesse!",
    "填写表格并获取有关加盟的详细信息。": "Preencha o formulário e receba informações detalhadas sobre a franquia.",
    提交提案: "Enviar proposta",
    谁已经在极兔速递的推动下增长: "Quem já está crescendo com a J&T",
    "看看一些正在与我们共同构建历史的加盟商。": "Conheça algumas franquias que estão construindo sua história conosco.",
    我们的客户: "Nossos Clientes",
    信任极兔速递进行物流运营的领先公司: "Empresas líderes que confiam na J&T Express para suas operações logísticas",
    我们的加盟商怎么说: "O que nossos franqueados dizem",
    "为什么选择极兔速递？": "Por que escolher a J&T Express?",
    经过验证的商业模式: "Modelo de negócio comprovado",
    "在数千次日常运营中测试和验证的运营系统,具有明确定义的流程和尖端技术。":
      "Sistema operacional testado e validado em milhares de operaçõesdiárias, com processos bem definidos e tecnologia de ponta.",
    独家和受保护的领地: "Território exclusivo e protegido",
    "通过区域独家权确保您的运营区域,在没有内部竞争的情况下最大化您的市场潜力。":
      "Garanta sua área de atuação com exclusividade territorial, maximizando seu potencial de mercado sem concorrência interna.",
    技术和持续创新: "Tecnologia e inovação constante",
    "访问专有管理系统、实时跟踪和优化运营的工具。":
      "Acesso a sistemas de gestão proprietários, rastreamento em teempo real e ferramentas que otimizam sua operação",
    "加入极兔革新您所在地区的物流格局。": "Junte-se à J&T e revolucione o cenário logístico da sua região.",
    "先到者,得更多。": "Quem chega primeiro, conquista mais.",
    "注册已提交！": "Cadastro enviado!",
    "我们已收到您的信息。我们的团队将很快与您联系，继续您作为极兔速递收集点的注册。":
      "Recebemos suas informações. Nossa equipe entrará em contato em breve para dar continuidade ao seu cadastro como ponto de coleta J&T Express.",
    提交新注册: "Enviar novo cadastro",
    Pudo1: {
      name: "Gabriela Bizio",
      location: "São Paulo",
      text: "Desde o início da nossa parceria, o que mais me impressiona é o comprometimento da empresa com a eficiência e o respeito aos seus colaboradores e parceiros. É gratificante fazer parte de uma estrutura que valoriza a agilidade sem comprometer a qualidade.",
    },
    Pudo2: {
      name: "Marcelo Vilalva",
      location: "Campo Grande",
      text: "Hoje, já estamos avaliando a possibilidade de ampliar nossa estrutura para acompanhar a crescente demanda. Essa experiência nos mostrou que a parceria com a J&T Express não apenas fortaleceu nosso negócio, mas também trouxe benefícios diretos aos clientes, que agora contam com mais comodidade e eficiência no envio de seus pedidos.",
    },
    Pudo3: {
      name: "Almenildo Santos",
      location: "Rio de Janeiro",
      text: "A J&T é uma parceira confiável, e tenho orgulho de fazer parte do time de uma empresa de envios que mais cresce e se desenvolve no mundo digital. A J&T trabalha com transparência, respostas rápidas e busca sempre melhorias para oferecer o melhor atendimento aos clientes.",
    },
    Pudo4: {
      name: "Talita Previatti",
      location: "São Paulo",
      text: "Sou ponto de coleta J&T Express desde março de 2025 e o que tenho a dizer é que a parceria é muito boa. Desde que comecei, o processo sempre foi muito simples e fácil, e continua sendo até hoje, e melhorando cada vez mais.",
    },
    Fran1: {
      name: "WERONICE",
      location: "Foz do Iguaçu",
      text: "Se me perguntassem o que eu esperava colher num futuro próximo dessa parceria, eu não teria ideia da imensidão de benefícios que colheríamos dela.",
    },
    Fran2: {
      name: "Ricardo Alves",
      location: "Campinas",
      text: "A estrutura operacional elevou completamente nossos padrões de entrega.",
    },
    Fran3: {
      name: "Juliana Moraes",
      location: "Belo Horizonte",
      text: "O suporte estratégico fez toda a diferença no nosso crescimento.",
    },
    Fran4: {
      name: "Marcos Vinícius",
      location: "Curitiba",
      text: "A tecnologia trouxe mais eficiência e confiança aos nossos clientes.",
    },
    Fran5: {
      name: "Aline Souza",
      location: "Recife",
      text: "A parceria nos trouxe estabilidade e expansão sustentável.",
    },
    Fran6: {
      name: "Fernando Lima",
      location: "Goiânia",
      text: "Operação sólida, com visão estratégica clara e foco em crescimento.",
    },
  },
  fulfill: {
    以仓为核重构巴西物流布局: "Com o armazém como centro, redesenhamos toda a logística no Brasil",
    通过分布式智能云仓网络我们建立了下一代供应链示范实现:
      "Por meio de uma rede distribuída e inteligente de armazéns em nuvem, criamos um modelo de próxima geração de cadeia de suprimentos que permite:",
    商品前置化: "Posicionamento antecipado dos produtos",
    履约无缝化: "Cumprimento de pedidos sem interrupções",
    响应敏捷化: "Respostas mais ágeis e eficientes",
    以仓库为中心我们重新设计了巴西的整个物流体系: "Com o armazém como centro, redesenhamos toda a logística no Brasil",
    通过分布式智能云仓网络我们创建了下一代供应链模型实现了:
      "Por meio de uma rede distribuída e inteligente de armazéns em nuvem, criamos um modelo de próxima geração de cadeia de suprimentos que permite:",
    产品的提前布局: "Posicionamento antecipado dos produtos",
    订单无间断履行: "Cumprimento de pedidos sem interrupções",
    更快速高效的响应: "Respostas mais ágeis e eficientes",
    联系我们: "Manifeste seu interesse!",
    填写表格并获取我们的仓储履约服务信息: "Preencha o formulário e receba informações detalhadas sobre nossos serviços de Fulfillment.",
    基础信息: "Informações Básicas",
    公司名称必填: "* Razão Social",
    CNPJCPF必填: "* CNPJ/CPF",
    联系人必填: "* Nome do Contato",
    电话必填: "* Telefone (WhatsApp)",
    邮箱必填: "* E-mail",
    业务规模: "Escala do Negócio",
    月订单量: "Pedidos por mês",
    SKU数量: "Quantidade de SKUs",
    需要的服务可多选: "Serviços",
    仓储: "Armazenagem",
    一件代发: "Fulfillment",
    退货处理: "Logística Reversa",
    发送提案: "Enviar proposta",
    请输入公司名称: "Informe a Razão Social",
    公司名称长度不能超过60字符: "A Razão Social não pode exceder 60 caracteres",
    请输入CNPJCPF: "Informe o CNPJ/CPF",
    CNPJCPF格式不正确: "CNPJ/CPF inválido",
    请输入联系人: "Informe o nome do contato",
    联系人长度不能超过50字符: "O nome do contato não pode exceder 50 caracteres",
    请输入电话: "Informe o telefone",
    电话格式不正确: "Telefone inválido",
    请输入邮箱: "Informe o e-mail",
    邮箱格式不正确: "E-mail inválido",
    标有星号的字段为必填项: "Campos marcados com * são obrigatórios",
    了解更多: "Quero saber mais",
    联系邮箱: "E-mail de contato",
    自研仓储管理系统: "Sistema de Gestão de Armazém Auto-desenvolvido",
    自研仓储管理系统描述1:
      "Através do nosso sistema de gestão de armazém auto-desenvolvido, integramos múltiplas plataformas. O sistema permite operações padronizadas e inteligentes, complementando e aprimorando a gestão unificada de toda a cadeia e promovendo eficiência operacional.",
    自研仓储管理系统描述2:
      "Desde a entrada de produtos até a distribuição, estamos otimizando cada etapa através do gerenciamento de dados para responder rapidamente às demandas do mercado.",
    运营优势: "Vantagens Operacionais",
    仓库网络: "Rede de Armazéns",
    仓库网络描述:
      "Aprimoramos a estrutura global de armazéns e da rede logística de última milha, impulsionando vendedores de comércio exterior a expandirem globalmente e garantindo a integração perfeita da rede logística mundial.",
    全国覆盖: "Cobertura nacional completa",
    区域物流中心: "Centros logísticos regionais",
    优化分发: "Distribuição otimizada",
    自有终端: "Terminal Próprio",
    自有终端描述: "Rede de entregas presente em 13 países, com ampla cobertura e serviços de distribuição abrangentes.",
    受控配送: "Entrega controlada",
    实时跟踪: "Rastreamento em tempo real",
    保证质量: "Qualidade garantida",
    集成存储和配送: "Armazenagem e Distribuição Integradas",
    集成存储和配送描述:
      "O armazém está localizado no Parque do Centro Logístico J&T, com suporte do centro de triagem de encomendas, permitindo a coleta integrada e sem interrupções.",
    集成流程: "Processo integrado",
    降低成本: "Redução de custos",
    更高效率: "Maior eficiência",
    完整的产品解决方案: "Solução Completa de Produtos",
    完整的产品解决方案描述:
      "Foco em B2B e B2C, com integração entre armazenagem e distribuição como núcleo. Por meio de uma estrutura diversificada de armazéns e serviços profissionais de entrega na última milha, oferece uma solução completa para a cadeia de suprimentos transfronteiriça (incluindo transporte principal/troncal, desembaraço aduaneiro, armazenagem, distribuição e serviços de devolução).",
    定制服务: "Serviço customizado",
    运营灵活性: "Flexibilidade operacional",
    全面支持: "Suporte total",
    多平台管理: "Gestão Multiplataforma",
    多平台管理描述:
      "Suporta reabastecimento de múltiplas lojas, múltiplos países e múltiplas plataformas / armazém do comerciante / entrega em supermercados físicos e lojas, realizando o inventário unificado 2B2C.",
    与Shopee和MercadoLivre等集成: "Integração com Shopee, Mercado Livre e mais",
    统一库存可见性: "Visibilidade unificada de estoque",
    实时同步: "Sincronização em tempo real",
    运营质量: "Qualidade Operacional",
    运营质量描述: "Por meio do monitoramento digital da qualidade operacional, oferecemos serviços abrangentes, de alta eficiência e alta qualidade.",
    进出检查: "Inspeção de entrada e saída",
    最低错误率: "Taxas de erro mínimas",
    详细质量报告: "Relatórios de qualidade detalhados",
    专业团队: "Equipe Especializada",
    专业团队描述:
      "Equipe profissional de suporte, sistema próprio e totalmente gerido de armazenagem e distribuição, além de equipe local de gestão no exterior, garantindo operações estáveis.",
    认证专业人员: "Profissionais certificados",
    持续培训: "Treinamento contínuo",
    客户专属支持: "Suporte dedicado ao cliente",
    标准化服务: "Serviços Padronizados",
    标准化仓储和配送服务: "STANDARDIZED WAREHOUSING AND DISTRIBUTION SERVICES",
    定制仓储服务: "CUSTOMIZED WAREHOUSE SERVICE",
    增值服务: "Serviços de Valor Agregado",
    头程服务: "Serviços de Primeira Milha",
    国内揽收服务: "Coleta de fornecedores",
    空海运头程: "Recebimento de mercadorias",
    多式联运: "Diversos canais",
    仓内存储: "Armazenagem Interna",
    入口接收: "Recebimento de entrada",
    库存管理: "Gestão de estoque",
    质量控制: "Controle de qualidade",
    交货时间监控: "Monitoramento de prazo",
    最终配送: "Entrega Final",
    订单生成: "Geração de pedidos",
    订单跟踪: "Rastreamento de encomendas",
    负载生成: "Geração de cargas",
    平台仓库: "Armazém de Plataforma",
    电子商务平台集成: "Integração com plataformas de e-commerce",
    统一供应链管理: "Gestão unificada da cadeia de suprimentos",
    类别仓库: "Armazém por Categoria",
    产品类型专业化: "Especialização por tipo de produto",
    类别优化管理: "Gestão otimizada por categoria",
    如服装鞋子电子产品美容产品等: "Como vestuário, calçados, eletrônicos, produtos de beleza, etc.",
    定制仓库: "Armazém Personalizado",
    基于客户需求的定制解决方案: "Soluções sob medida conforme necessidades do cliente",
    入库流程: "Processo de Entrada",
    质量检查: "Inspeção de qualidade",
    二次标签: "Etiquetagem secundária",
    外部分发: "Distribuição externa",
    出库流程: "Processo de Saída",
    集成包装: "Embalagem integrada",
    礼品包装: "Embalagem de presentes",
    包装定制: "Customização de embalagem",
    促销管理: "Gestão de promoções",
    售后和退货: "Pós-Venda e Devoluções",
    照片上传: "Upload de fotos",
    退货检查: "Inspeção de devoluções",
    测试: "Testes",
    回收: "Reciclagem",
    视觉报告: "Relatórios Visuais",
    名确认: "Confirmação por assinatura",
    签名确认: "Confirmação por assinatura",
    报告审核: "Auditoria de relatórios",
    发货认证: "Certificação de envio",
    配送跟踪: "Rastreamento de entregas",
    "加载失败，请刷新页面重试": "Carregamento falhou, por favor, tente novamente",
  },
};
